/**
 * Beauty Bliss — Clinical Purity Theme
 * Base JavaScript: Carousel, Cart Drawer, Mobile Menu, Search Overlay, Quantity Controls
 */

(function () {
  'use strict';

  /* ==========================================================================
     1. HERO SLIDESHOW (Manual controls + pause autoplay on interaction)
     ========================================================================== */
  const hero = document.querySelector('.hero-slideshow');
  const heroTrack = document.getElementById('hero-track');
  const heroIndicators = document.getElementById('hero-indicators');

  if (hero && heroTrack) {
    const dots = heroIndicators ? heroIndicators.querySelectorAll('.hero-slideshow__dot') : [];
    const slides = heroTrack.querySelectorAll('.hero-slideshow__slide');
    const toggle = hero.querySelector('.hero-slideshow__toggle');
    const count = slides.length;
    const autoplay = heroTrack.getAttribute('data-autoplay') === 'true';
    const interval = parseInt(heroTrack.getAttribute('data-interval'), 10) || 6000;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let currentSlide = 0;
    let timer = null;
    let userPaused = false;
    let touchStartX = 0;
    let touchStartY = 0;

    function setToggleState(playing) {
      if (!toggle) return;
      toggle.setAttribute('data-playing', playing ? 'true' : 'false');
      toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
      toggle.setAttribute('aria-label', playing ? toggle.getAttribute('data-label-pause') : toggle.getAttribute('data-label-play'));
    }

    function goToSlide(index) {
      if (!count) return;
      currentSlide = (index + count) % count;
      var slideWidth = hero.clientWidth;
      slides.forEach(function (slide) {
        slide.style.flexBasis = slideWidth + 'px';
        slide.style.width = slideWidth + 'px';
      });
      heroTrack.style.transform = 'translate3d(' + (-currentSlide * slideWidth) + 'px, 0, 0)';

      slides.forEach(function (slide, i) {
        const active = i === currentSlide;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });

      dots.forEach(function (dot, i) {
        const active = i === currentSlide;
        dot.classList.toggle('hero-slideshow__dot--active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (userPaused || !autoplay || reduceMotion || count < 2) return;
      timer = setInterval(function () {
        goToSlide(currentSlide + 1);
      }, interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(parseInt(this.getAttribute('data-slide'), 10));
        startAutoplay();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        setToggleState(!userPaused);
        if (userPaused) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
    }

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);
    hero.addEventListener('focusin', stopAutoplay);
    hero.addEventListener('focusout', function (event) {
      if (!hero.contains(event.relatedTarget)) startAutoplay();
    });
    hero.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToSlide(currentSlide + 1);
        startAutoplay();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToSlide(currentSlide - 1);
        startAutoplay();
      }
    });

    hero.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
      stopAutoplay();
    }, { passive: true });

    hero.addEventListener('touchend', function (event) {
      var dx = event.changedTouches[0].clientX - touchStartX;
      var dy = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        goToSlide(currentSlide + (dx < 0 ? 1 : -1));
      }
      startAutoplay();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    window.addEventListener('resize', function () {
      goToSlide(currentSlide);
    });

    goToSlide(0);
    startAutoplay();
  }

  /* ==========================================================================
     2. CART DRAWER
     ========================================================================== */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  var cartDrawerOpen = document.getElementById('cart-drawer-open');
  var cartDrawerClose = document.getElementById('cart-drawer-close');
  var CART_DRAWER_REOPEN_KEY = 'bbCartDrawerReopen';

  function openCartDrawer() {
    if (!cartDrawer || !cartDrawerOverlay) return;
    cartDrawer.classList.add('is-open');
    cartDrawerOverlay.classList.add('is-open');
    document.body.classList.add('drawer-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawerOverlay.setAttribute('aria-hidden', 'false');

    var fill = document.getElementById('cart-drawer-progress-fill');
    var ring = document.getElementById('cart-drawer-progress-ring');
    if (fill && ring && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var target = parseFloat(ring.style.getPropertyValue('--cart-progress')) || 0;
      fill.setAttribute('stroke-dasharray', '0 100');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fill.setAttribute('stroke-dasharray', target + ' 100');
        });
      });
    }
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartDrawerOverlay) return;
    cartDrawer.classList.remove('is-open');
    cartDrawerOverlay.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawerOverlay.setAttribute('aria-hidden', 'true');
  }

  try {
    if (sessionStorage.getItem(CART_DRAWER_REOPEN_KEY) === '1') {
      sessionStorage.removeItem(CART_DRAWER_REOPEN_KEY);
      openCartDrawer();
    }
  } catch (e) {}

  if (cartDrawerOpen) {
    cartDrawerOpen.addEventListener('click', openCartDrawer);
  }
  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }

  // Cart drawer: remove item + quantity adjust
  document.querySelectorAll('.cart-drawer__item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(this.getAttribute('data-line'), 10);
      updateCartLine(line, 0);
    });
  });

  document.querySelectorAll('.cart-drawer__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(this.getAttribute('data-line'), 10);
      var action = this.getAttribute('data-action');
      var input = document.querySelector('.cart-drawer__qty-input[data-line="' + line + '"]');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 0;
      if (action === 'increase') qty += 1;
      if (action === 'decrease') qty -= 1;
      if (qty < 0) qty = 0;
      input.value = qty;
      updateCartLine(line, qty);
    });
  });

  document.querySelectorAll('.cart-drawer__qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = parseInt(this.getAttribute('data-line'), 10);
      var qty = parseInt(this.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      this.value = qty;
      updateCartLine(line, qty);
    });
  });

  function setCartQtyControlsDisabled(disabled) {
    document.querySelectorAll('.cart-drawer__qty-btn, .cart-drawer__qty-input, .cart-drawer__item-remove').forEach(function (el) {
      el.disabled = !!disabled;
    });
  }

  function updateCartLine(line, quantity) {
    setCartQtyControlsDisabled(true);
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (!document.querySelector('.cart-drawer--page')) {
          try { sessionStorage.setItem(CART_DRAWER_REOPEN_KEY, '1'); } catch (e) {}
        }
        window.location.reload();
      })
      .catch(function (err) {
        console.error('Cart update failed:', err);
        setCartQtyControlsDisabled(false);
      });
  }

  function formatCartMoney(cents) {
    var format = (cartDrawer && cartDrawer.getAttribute('data-money-format')) || '${{amount}}';
    var value = (Number(cents) / 100).toFixed(2);
    var parts = value.split('.');
    var amountNoDecimals = parts[0];
    var amountWithComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '');
    var amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + (parts[1] || '00');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function setDiscountFeedback(message, state) {
    var feedback = document.getElementById('cart-drawer-discount-feedback');
    if (!feedback) return;
    feedback.hidden = !message;
    feedback.textContent = message || '';
    feedback.classList.remove('is-success', 'is-error');
    if (state) feedback.classList.add(state);
  }

  function setCircularProgress(pct) {
    var value = Math.max(0, Math.min(100, pct));
    var fill = document.getElementById('cart-drawer-progress-fill');
    var ring = document.getElementById('cart-drawer-progress-ring');
    if (fill) fill.setAttribute('stroke-dasharray', value + ' 100');
    if (ring) {
      ring.style.setProperty('--cart-progress', String(value));
      ring.setAttribute('aria-valuenow', String(Math.round(value)));
    }
  }

  function updateShippingCopy(freeUnlocked, remainingCents) {
    var shippingWrap = document.getElementById('cart-drawer-shipping');
    var shippingMsg = document.getElementById('cart-drawer-shipping-msg');
    if (!shippingWrap || !shippingMsg || !cartDrawer) return;

    shippingWrap.classList.toggle('cart-drawer__shipping--unlocked', !!freeUnlocked);
    var highlight = cartDrawer.getAttribute('data-i18n-shipping-highlight') || 'Free shipping!';
    var line = '';
    if (freeUnlocked) {
      line = cartDrawer.getAttribute('data-i18n-shipping-unlocked-line') || "You've unlocked";
    } else {
      var tmpl = cartDrawer.getAttribute('data-i18n-shipping-remaining-line') || 'Buy __AMOUNT__ more to enjoy';
      line = tmpl.replace('__AMOUNT__', formatCartMoney(remainingCents));
    }
    shippingMsg.innerHTML =
      '<p class="cart-drawer__ship-line">' + line + '</p>' +
      '<p class="cart-drawer__ship-highlight">' + highlight + '</p>';
  }

  function updateCartDrawerTotals(cart) {
    if (!cartDrawer || !cart) return;

    var subtotalEl = document.getElementById('cart-drawer-subtotal-amount');
    if (subtotalEl) subtotalEl.textContent = formatCartMoney(cart.total_price);

    var checkoutAmount = document.getElementById('cart-drawer-checkout-amount');
    if (checkoutAmount) checkoutAmount.textContent = formatCartMoney(cart.total_price);

    var savingsEl = document.getElementById('cart-drawer-savings');
    var savingsAmount = document.getElementById('cart-drawer-savings-amount');
    if (savingsEl && savingsAmount) {
      if (cart.total_discount > 0) {
        savingsEl.hidden = false;
        savingsAmount.textContent = '−' + formatCartMoney(cart.total_discount);
      } else {
        savingsEl.hidden = true;
      }
    }

    var threshold = parseInt(cartDrawer.getAttribute('data-free-shipping-threshold') || '0', 10);
    if (threshold > 0 && document.getElementById('cart-drawer-shipping')) {
      var remaining = Math.max(0, threshold - cart.total_price);
      var progressPct = Math.min(100, (cart.total_price / threshold) * 100);
      var freeUnlocked = remaining === 0;
      setCircularProgress(progressPct);
      updateShippingCopy(freeUnlocked, remaining);
    }

    cartDrawer.setAttribute('data-cart-total', String(cart.total_price));
  }

  function applyCartDiscountCode() {
    var input = document.getElementById('cart-drawer-discount-input');
    var applyBtn = document.getElementById('cart-drawer-discount-apply');
    if (!input || !cartDrawer) return;

    var code = (input.value || '').trim();
    if (!code) {
      setDiscountFeedback(cartDrawer.getAttribute('data-i18n-discount-empty') || '', 'is-error');
      return;
    }

    if (applyBtn) {
      applyBtn.disabled = true;
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartDrawerTotals(cart);

            var discountMatched = false;
            if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
              discountMatched = cart.cart_level_discount_applications.some(function (app) {
                return String(app.title || '').toLowerCase() === code.toLowerCase();
              });
            }
            if (!discountMatched && cart.discount_codes && cart.discount_codes.length) {
              discountMatched = cart.discount_codes.some(function (d) {
                return d && d.applicable !== false && String(d.code || '').toLowerCase() === code.toLowerCase();
              });
            }
            if (!discountMatched && cart.total_discount > 0) {
              discountMatched = true;
            }

            if (discountMatched && cart.total_discount > 0) {
              var appliedTmpl = cartDrawer.getAttribute('data-i18n-discount-applied') || '';
              setDiscountFeedback(
                appliedTmpl.replace('__AMOUNT__', formatCartMoney(cart.total_discount)),
                'is-success'
              );
            } else if (result.ok && cart.total_discount > 0) {
              var appliedTmpl2 = cartDrawer.getAttribute('data-i18n-discount-applied') || '';
              setDiscountFeedback(
                appliedTmpl2.replace('__AMOUNT__', formatCartMoney(cart.total_discount)),
                'is-success'
              );
            } else {
              setDiscountFeedback(cartDrawer.getAttribute('data-i18n-discount-invalid') || '', 'is-error');
            }
          });
      })
      .catch(function (err) {
        console.error('Discount apply failed:', err);
        setDiscountFeedback(cartDrawer.getAttribute('data-i18n-discount-invalid') || '', 'is-error');
      })
      .finally(function () {
        if (applyBtn) applyBtn.disabled = false;
      });
  }

  var discountApplyBtn = document.getElementById('cart-drawer-discount-apply');
  var discountInput = document.getElementById('cart-drawer-discount-input');
  if (discountApplyBtn) {
    discountApplyBtn.addEventListener('click', applyCartDiscountCode);
  }
  if (discountInput) {
    discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyCartDiscountCode();
      }
    });
  }

  /* Cart drawer: In the same range expand + carousel */
  function syncCartRangeCarousel(rangeRoot) {
    if (!rangeRoot) return;
    var track = rangeRoot.querySelector('[data-cart-range-track]');
    var slides = rangeRoot.querySelectorAll('[data-cart-range-slide]');
    var prevBtn = rangeRoot.querySelector('[data-cart-range-prev]');
    var nextBtn = rangeRoot.querySelector('[data-cart-range-next]');
    if (!track || !slides.length) return;

    var index = parseInt(rangeRoot.getAttribute('data-range-index') || '0', 10);
    if (isNaN(index) || index < 0) index = 0;
    if (index > slides.length - 1) index = slides.length - 1;
    rangeRoot.setAttribute('data-range-index', String(index));
    track.style.transform = 'translateX(-' + index * 100 + '%)';
    if (prevBtn) prevBtn.disabled = index <= 0;
    if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
  }

  document.querySelectorAll('[data-cart-range]').forEach(function (rangeRoot) {
    rangeRoot.setAttribute('data-range-index', '0');
    syncCartRangeCarousel(rangeRoot);

    var toggle = rangeRoot.querySelector('[data-cart-range-toggle]');
    var panel = rangeRoot.querySelector('[data-cart-range-panel]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          panel.hidden = true;
        } else {
          panel.hidden = false;
          syncCartRangeCarousel(rangeRoot);
        }
      });
    }

    var prevBtn = rangeRoot.querySelector('[data-cart-range-prev]');
    var nextBtn = rangeRoot.querySelector('[data-cart-range-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var index = parseInt(rangeRoot.getAttribute('data-range-index') || '0', 10) - 1;
        rangeRoot.setAttribute('data-range-index', String(Math.max(0, index)));
        syncCartRangeCarousel(rangeRoot);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var slides = rangeRoot.querySelectorAll('[data-cart-range-slide]');
        var index = parseInt(rangeRoot.getAttribute('data-range-index') || '0', 10) + 1;
        rangeRoot.setAttribute('data-range-index', String(Math.min(slides.length - 1, index)));
        syncCartRangeCarousel(rangeRoot);
      });
    }
  });

  document.querySelectorAll('[data-cart-range-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = parseInt(this.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      var addBtn = this;
      addBtn.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          if (!document.querySelector('.cart-drawer--page')) {
            try { sessionStorage.setItem(CART_DRAWER_REOPEN_KEY, '1'); } catch (e) {}
          }
          window.location.reload();
        })
        .catch(function (err) {
          console.error('Range add to cart failed:', err);
          addBtn.disabled = false;
        });
    });
  });

  /* ==========================================================================
     3. MOBILE MENU
     ========================================================================== */
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  var mobileMenuOpen = document.getElementById('mobile-menu-open');
  var mobileMenuClose = document.getElementById('mobile-menu-close');

  function openMobileMenu() {
    if (!mobileMenu || !mobileMenuOverlay) return;
    mobileMenu.classList.add('is-open');
    mobileMenuOverlay.classList.add('is-open');
    document.body.classList.add('menu-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenuOverlay.setAttribute('aria-hidden', 'false');

    if (mobileMenuOpen) {
      var menuIcon = mobileMenuOpen.querySelector('.material-symbols-outlined');
      if (menuIcon) menuIcon.textContent = 'close';
      mobileMenuOpen.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMobileMenu() {
    if (!mobileMenu || !mobileMenuOverlay) return;
    mobileMenu.classList.remove('is-open');
    mobileMenuOverlay.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenuOverlay.setAttribute('aria-hidden', 'true');

    if (window.BBMobileNav && typeof window.BBMobileNav.reset === 'function') {
      window.BBMobileNav.reset();
    }

    if (mobileMenuOpen) {
      var menuIcon = mobileMenuOpen.querySelector('.material-symbols-outlined');
      if (menuIcon) menuIcon.textContent = 'menu';
      mobileMenuOpen.setAttribute('aria-expanded', 'false');
    }
  }

  if (mobileMenuOpen) {
    mobileMenuOpen.addEventListener('click', function () {
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', closeMobileMenu);
  }

  /* ==========================================================================
     4. SEARCH OVERLAY
     ========================================================================== */
  var searchOverlay = document.getElementById('search-overlay');
  var searchOpen = document.getElementById('search-open');
  var searchClose = document.getElementById('search-close');
  var searchInput = document.getElementById('search-input');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    document.body.classList.add('search-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    if (searchInput) {
      setTimeout(function () { searchInput.focus(); }, 100);
    }
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    document.body.classList.remove('search-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }

  if (searchOpen) {
    searchOpen.addEventListener('click', openSearch);
  }
  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileMenu();
      closeSearch();
    }
  });

  /* ==========================================================================
     5. PREDICTIVE SEARCH
     ========================================================================== */
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function readCardBannerConfig() {
    var node = document.getElementById('card-banner-config');
    if (!node || !node.textContent) return null;
    try {
      var parsed = JSON.parse(node.textContent);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (err) {
      return null;
    }
  }

  function cardBannerCopy(banner) {
    var en = (banner.lines && banner.lines.en) || [];
    var line1 = en.length ? String(en[0]).trim() : '';
    var line2 = en.length > 1 ? String(en[en.length - 1]).trim() : '';
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var zh = banner.lines && banner.lines.zh;

    if (lang.indexOf('zh') !== -1 && zh && zh.length) {
      var zh1 = zh[0] ? String(zh[0]).trim() : '';
      var zh2 = zh.length > 1 && zh[zh.length - 1] ? String(zh[zh.length - 1]).trim() : '';
      if (zh1) line1 = zh1;
      if (zh2) line2 = zh2;
    }

    if (!line2 || line2 === line1) line2 = '';
    return { line1: line1, line2: line2 };
  }

  function idListHas(list, id) {
    if (!list || !list.length) return false;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i]) === id) return true;
    }
    return false;
  }

  // Search JSON has no collections, so collection include/exclude rules are skipped here.
  function cardBannerSearchHtml(banner, productId) {
    if (!banner || banner.active !== true) return '';

    var now = Date.now();
    if (banner.startsAt) {
      var start = Date.parse(banner.startsAt);
      if (!isNaN(start) && now < start) return '';
    }
    if (banner.endsAt) {
      var end = Date.parse(banner.endsAt);
      if (!isNaN(end) && now > end) return '';
    }

    var id = String(productId);
    if (idListHas(banner.excludeProductIds, id)) return '';

    var included = banner.includeAll === true || banner.includeAll === 'true';
    if (!included && !idListHas(banner.includeProductIds, id)) return '';

    var copy = cardBannerCopy(banner);
    if (!copy.line1) return '';

    var html = '<p class="card-banner-search">';
    html += '<span class="card-banner-search__line">' + escapeHtml(copy.line1) + '</span>';
    if (copy.line2) {
      html += '<span class="card-banner-search__line">' + escapeHtml(copy.line2) + '</span>';
    }
    html += '</p>';
    return html;
  }

  if (searchInput) {
    var searchResults = document.getElementById('search-results');
    var searchDebounce = null;

    searchInput.addEventListener('input', function () {
      var query = this.value.trim();
      clearTimeout(searchDebounce);

      if (query.length < 2) {
        if (searchResults) searchResults.innerHTML = '';
        return;
      }

      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (!searchResults) return;
            var products = data.resources && data.resources.results && data.resources.results.products
              ? data.resources.results.products
              : [];

            if (products.length === 0) {
              searchResults.innerHTML = '<p class="text-body-md color-on-surface-variant" style="padding: 16px 0;">No results found.</p>';
              return;
            }

            var cardBanner = readCardBannerConfig();
            var html = '<div class="grid grid-3" style="gap: 16px;">';
            products.forEach(function (product) {
              html += '<a href="' + product.url + '" style="display: flex; gap: 12px; align-items: center; padding: 8px 0; border-bottom: 1px solid var(--color-outline-variant);">';
              if (product.image) {
                html += '<img src="' + product.image + '" alt="" style="width: 48px; height: 60px; object-fit: cover; border: 0.5px solid var(--color-outline-variant);">';
              }
              html += '<div>';
              html += '<p class="text-body-md" style="font-weight: 700;">' + product.title + '</p>';
              html += cardBannerSearchHtml(cardBanner, product.id);
              html += '<p class="text-body-md color-on-surface-variant">' + product.price + '</p>';
              html += '</div></a>';
            });
            html += '</div>';
            searchResults.innerHTML = html;
          })
          .catch(function () {
            if (searchResults) searchResults.innerHTML = '';
          });
      }, 300);
    });
  }

  /* ==========================================================================
     6. QUANTITY CONTROLS (Product page + Cart page)
     ========================================================================== */
  document.querySelectorAll('.product-form__quantity-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var container = this.closest('.product-form__quantity');
      var input = container.querySelector('.product-form__quantity-input');
      var currentVal = parseInt(input.value, 10) || 1;
      var action = this.getAttribute('data-action');

      if (action === 'increase') {
        input.value = currentVal + 1;
      } else if (action === 'decrease' && currentVal > 1) {
        input.value = currentVal - 1;
      }

      // Trigger change event for any listeners
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ==========================================================================
     7. PRODUCT PAGE: Thumbnail gallery click
     ========================================================================== */
  document.querySelectorAll('[data-image-url]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImage = document.getElementById('product-main-image');
      if (mainImage) {
        mainImage.src = this.getAttribute('data-image-url');
      }
    });
  });

  /* ==========================================================================
     8. ADD TO CART (AJAX) — intercept product forms (incl. late-loaded cards)
     ========================================================================== */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    // Only intercept if cart type is drawer
    var cartDrawerEl = document.getElementById('cart-drawer');
    if (!cartDrawerEl) return; // Let native form submit handle it

    e.preventDefault();
    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        // Reload to update cart drawer contents
        window.location.reload();
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
      });
  });
})();
